import { useMemo } from 'react'
import { CSVField } from 'hooks/useExportCSV'
import { csvColumnCreatedBy, csvColumnUpdatedBy } from 'features/UI'
import { formatDate, isDefined } from 'utils'
import { PLACEHOLDER } from 'components/column-renderers'
import { createSummaryTagsColumnCSV } from 'features/Tags/models/TagsColumn'

export function useCoursesCSVField() {
  return useMemo<CSVField[]>(
    () => [
      {
        label: 'Course Name',
        value: 'name',
      },
      {
        label: 'Number of Lessons',
        value: 'numberOfLessons',
      },
      {
        label: 'Exam',
        value: ({ questionnaireId }) => (isDefined(questionnaireId) ? 'created' : PLACEHOLDER),
      },
      {
        label: 'Published',
        value: ({ isPublished }) => (isPublished ? 'Published' : 'Unpublished'),
      },
      createSummaryTagsColumnCSV('lessons'),
      {
        label: 'Creation Date',
        value: ({ createdAt }) => formatDate(createdAt),
      },
      csvColumnCreatedBy(),
      {
        label: 'Last Edited',
        value: ({ updatedAt }) => formatDate(updatedAt),
      },
      csvColumnUpdatedBy(),
    ],
    [],
  )
}
